import React from 'react'

class ThumbsUp extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40">
        <text y="32" font-size="32">
          👍
        </text>
      </svg>
    )
  }
}

export default ThumbsUp
